import { issues, IssuesKeys } from './components';

export const generateComment = (selectedIssue: IssuesKeys | null, comment: string) => {
  if (!selectedIssue) return '';

  return comment && selectedIssue ? `${issues[selectedIssue]}: ${comment}` : issues[selectedIssue];
};
